import React from "react";
import ContactUsBanner from "../Components/ContactUsComponents/ContactUsBanner";
import ConttactUsForm from "../Components/ContactUsComponents/ConttactUsForm";
import "../Components/ContactUsComponents/Contactus.css";
import { Helmet } from "react-helmet";
import Tagline from "../TagLine/Tagline";
const ContactUs = () => {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>Contact Us | Sreehari Diamond Laboratory </title>
        <meta
          name="description"
          content="Reach out to Sreehari Diamond Laboratory for inquiries, appointments, or service details. Call us at +919443736692 or +919442101562 for quick assistance."
        />
        <meta
          name="keywords"
          content="Contact us, lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="Contact Us | Sreehari Diamond Laboratory"
        />
        <meta
          property="og:description"
          content="Reach out to Sreehari Diamond Laboratory for inquiries, appointments, or service details. Call us at +919443736692 or +919442101562 for quick assistance."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content=" https://sreeharidiamondlab.com/contact-us"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/logo.04f6bad90dcf8391f785.png"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Contact Us | Sreehari Diamond Laboratory"
        />
        <meta
          name="twitter:description"
          content="Reach out to Sreehari Diamond Laboratory for inquiries, appointments, or service details. Call us at +919443736692 or +919442101562 for quick assistance."
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/logo.04f6bad90dcf8391f785.png"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/contact-us"
        />{" "}
      </Helmet>
      <div>
        <ContactUsBanner />
        <ConttactUsForm />
        <Tagline />
      </div>
    </>
  );
};

export default ContactUs;
